import {PolicyDTO} from '../PolicyDTO';
import {BaseDTO} from '../../../common/models/BaseDTO';
import {NameValueCodeDTO} from '../../../common/models/NameValueCodeDTO';

export class PersonPolicyProductLinkDTO extends BaseDTO {
  product: NameValueCodeDTO;
  policy: PolicyDTO;
  startDate: Date;
  endDate: Date;
  nominatedBeneficiaryNationalIdNumber: string;
}
